export const Regexp = {
  INTEGER: /^[0-9]+$/,
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  EXP_MONTH: /^((0[1-9])|(1[0-2]))$/,
  EXP_YEAR: /^(|(202[0-5]))$/,
  DERIVATIVE: /^(?!\s*$|\s).*$/,
};
